@if (laboratoire !== null) {
  <div>
    @if (laboratoire['laboratoireReference'] === null || laboratoire['laboratoireReference'] === undefined) {
      <div>
        <div class="row">
          <div class="col-12 mt-1 mb-1">
            @if (restrictCountryValue !== 'HORS_FR') {
              <button mat-raised-button color="warn" (click)="searchStructure()" [disabled]="disabled">
                <mat-icon class="mat-icon">search</mat-icon>
                {{ 'moduleLaboratoire.chercherStructureFrancaise' | translate }}
              </button>
            }
            @if (restrictCountryValue === '') {
              <span class="divider"
              style="margin-left: 10px; margin-right: 10px; font-weight: bold;">{{ 'general.ou' | translate }}</span>
            }
            @if (restrictCountryValue !== 'FR') {
              <button mat-raised-button color="warn" (click)="addNewLaboRef()" [disabled]="disabled">
                <mat-icon class="mat-icon">add</mat-icon>
                {{ 'moduleLaboratoire.ajouterHorsFrance' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    }
    @if (laboratoire['laboratoireReference'] !== null  && laboratoire['laboratoireReference'] !== undefined) {
      <div>
        <div class="row mt-1">
          <div class="col">
            <hr class="separator-structure">
            <span class="font-weight-bold encart-labo entete-part-labo">{{ 'moduleLaboratoire.structureRecherche' | translate }}</span>
          </div>
        </div>
        @if (!laboratoireReferenceModifiable()) {
          <div class="row">
            @if (laboratoire['laboratoireReference'] !== null && laboratoire['laboratoireReference'] !== undefined) {
              <div class="col-12">
                <p>{{ 'moduleLaboratoire.nomEtablissement' | translate }}
                  <strong>{{laboratoire['laboratoireReference']['label']}}</strong></p>
                  <p>{{ 'general.laboratoire.adresse' | translate }} <strong>
                    {{ laboratoire['laboratoireReference']['adresse']['adresseComplete'] ?? ''}}
                  </strong></p>
                  <p>{{ 'moduleLaboratoire.direction' | translate }} <strong>
                    {{(laboratoire['laboratoireReference']['directeur']['civilite'] === 'm') ? 'Mr. ' : 'Mme. '}}
                    {{laboratoire['laboratoireReference']['directeur']['nom']}}
                    {{laboratoire['laboratoireReference']['directeur']['prenom']}}
                  </strong></p>
                  <div>
                    <button mat-stroked-button matTooltip="{{ 'front.toolTip.signalerUneMiseJour' | translate }}"
                      color="accent" (click)="demandeDeModification()" [disabled]="disabled"
                      style="float: left;">
                      <mat-icon>feedback</mat-icon>
                      {{ 'front.profil.signalerModifcation' | translate }}
                    </button>
                    <button mat-stroked-button color="accent" (click)="deleteLaboRef()" [disabled]="disabled"
                      class="ml-1">
                      <mat-icon>autorenew</mat-icon>
                      {{ 'front.profil.supprimerStructure' | translate }}
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          @if (laboratoireReferenceModifiable()) {
            <div class="row">
              <div class="col">
                <div class="row mb-1">
                  <div class="col">
                    <button mat-stroked-button color="accent"
                      (click)="deleteLaboRef()"
                      [disabled]="disabled">
                      <mat-icon>autorenew</mat-icon>
                      {{ 'front.profil.supprimerStructure' | translate }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <fieldset class="form-group {{(!nomLaboratoire.valid) ? 'form-error' : ''}}">
                      <label for="label">{{ 'moduleLaboratoire.nomEtablissement' | translate }} <span
                      class="star">*</span> :</label>
                      <input type="text" class="form-control" id="label" [disabled]="disabled"
                        [(ngModel)]="laboratoire['laboratoireReference'].label" #nomLaboratoire="ngModel"
                        required (focusout)="updateLaboRef()">
                        <app-controls-messages [control]="nomLaboratoire"></app-controls-messages>
                      </fieldset>
                    </div>
                  </div>
                  @if (laboratoire && laboratoire['laboratoireReference'] && laboratoire['laboratoireReference']['adresse'] !== null) {
                    <div class="row">
                      <div class="col">
                        <form>
                          <app-geocoder [instance]="'LaboRef'" [adresse]="laboratoire['laboratoireReference'].adresse"
                            [restrictCountryValue]="'HORS_FR'" [disabled]="disabled"
                            (place)="laboratoire['laboratoireReference'].adresse = $event; updateLaboRef()"
                            >
                          </app-geocoder>
                        </form>
                      </div>
                    </div>
                  }
                  @if (laboratoire && laboratoire['laboratoireReference']
                    && laboratoire['laboratoireReference']['adresse'] && laboratoire['laboratoireReference']['adresse']['pays']
                    && (laboratoire['laboratoireReference']['adresse']['pays']['code'] === 'FR' || laboratoire['laboratoireReference']['adresse']['pays'] === '/api/countries/FR')) {
                    <div class="row">
                      <div class="col">
                        <p class="encart-labo">
                          {{'moduleLaboratoire.verifStructureFrance' | translate}}
                        </p>
                      </div>
                    </div>
                  }
                  <div class="row">
                    <div class="col-lg-12">
                      <p class="font-weight-bold margin-direction">{{ 'moduleLaboratoire.direction' | translate }}</p>
                    </div>
                  </div>
                  @if (laboratoire['laboratoireReference']['directeur'] !== undefined) {
                    <div class="row">
                      <div class="col-2">
                        <fieldset class="form-group {{(!directeurCivilite.valid) ? 'form-error' : ''}}">
                          <label for="directeurCivilite">{{ 'general.civilite' | translate }} <span
                          class="star">*</span></label>
                          <mat-select class="form-control" name="directeurCivilite" id="directeurCivilite"
                            [compareWith]="compareByLetter" #directeurCivilite="ngModel"
                            [disabled]="disabled"
                            [(ngModel)]="laboratoire['laboratoireReference']['directeur']['civilite']"
                            required (focusout)="updateLaboRef()">
                            <mat-option value="f">{{ 'general.madame' | translate }}</mat-option>
                            <mat-option value="m">{{ 'general.monsieur' | translate }}</mat-option>
                          </mat-select>
                          <app-controls-messages [control]="directeurCivilite"></app-controls-messages>
                        </fieldset>
                      </div>
                      <div class="col-5">
                        <fieldset class="form-group {{(!directeur_nom.valid) ? 'form-error' : ''}}">
                          <label for="directeur_nom">{{ 'general.personne.nom' | translate }} <span
                          class="star">*</span></label>
                          <input class="form-control" name="directeur_nom" id="directeur_nom" type="text"
                            #directeur_nom="ngModel" [disabled]="disabled"
                            [(ngModel)]="laboratoire['laboratoireReference']['directeur']['nom']" required
                            (focusout)="updateLaboRef()"/>
                            <app-controls-messages [control]="directeur_nom"></app-controls-messages>
                          </fieldset>
                        </div>
                        <div class="col-5">
                          <fieldset class="form-group {{(!directeur_prenom.valid) ? 'form-error' : ''}}">
                            <label for="directeur_prenom">{{ 'general.prenom' | translate }} <span class="star">*</span></label>
                            <input class="form-control" name="directeur_prenom" id="directeur_prenom" type="text"
                              #directeur_prenom="ngModel" [disabled]="disabled"
                              [(ngModel)]="laboratoire['laboratoireReference']['directeur']['prenom']" required
                              (focusout)="updateLaboRef()"/>
                              <app-controls-messages [control]="directeur_prenom"></app-controls-messages>
                            </fieldset>
                          </div>
                        </div>
                      }
                      @if (!laboRefEnFrance() && !isValid()) {
                        <div class="row">
                          <span class="col alert alert-danger ml-1 mr-1">
                            <i class="fa fa-exclamation-triangle"></i> <span class="ml-1">{{'moduleLaboratoire.structureACompleter' | translate }}</span>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (laboRefEnFrance()) {
              <div>
                <div class="row mt-2">
                  <div class="col">
                    <hr class="separator-structure">
                    <span class="font-weight-bold encart-labo entete-part-labo">{{ 'moduleLaboratoir.precisezLaboratoire' | translate }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <fieldset class="form-group {{(!laboNom.valid) ? 'form-error' : ''}}">
                      <label for="etablissement">{{ 'moduleLaboratoire.nomLaboratoireUniteService' | translate }} <span
                      class="star">*</span></label>
                      <input id="etablissement"
                        placeholder="{{ 'moduleLaboratoire.saisisezNomEtablissement' | translate }}" type="text"
                        class="form-control" #laboNom="ngModel" required [(ngModel)]="laboratoire['nom']"
                        [disabled]="disabled"
                        (ngModelChange)="updateLaboratoire.emit(laboratoire);">
                        <app-controls-messages [control]="laboNom"></app-controls-messages>
                      </fieldset>
                    </div>
                    <div class="col-4">
                      <fieldset class="form-group">
                        <label for="equipe">{{ 'general.equipe' | translate }}</label>
                        <input id="equipe" placeholder="{{ 'moduleLaboratoire.saisissezEquipe' | translate }}" type="text"
                          class="form-control" [disabled]="disabled"
                          [(ngModel)]="laboratoire['division']" (ngModelChange)="updateLaboratoire.emit(laboratoire);">
                        </fieldset>
                      </div>
                    </div>
                    @if (laboratoire['directeurDivision'] !== null) {
                      <div class="row">
                        <div class="col">
                          <p class="font-weight-bold">{{ 'moduleLaboratoire.direction' | translate }}</p>
                        </div>
                      </div>
                    }
                    @if (laboratoire['directeurDivision'] !== null) {
                      <div class="row">
                        <div class="col">
                          <fieldset class="form-group {{(!laboDirecteurDivision.valid) ? 'form-error' : ''}}">
                            <label for="civilite">{{ 'general.civilite' | translate }} <span class="star">*</span> </label>
                            <mat-select class="form-control"
                              [(ngModel)]="laboratoire['directeurDivision']['personne']['civilite']"
                              id="civilite" #laboDirecteurDivision="ngModel" [compareWith]="compareByLetter" required
                              [disabled]="disabled"
                              (ngModelChange)="updateLaboratoire.emit(laboratoire);">
                              <mat-option value="f">{{ 'general.madame' | translate }}</mat-option>
                              <mat-option value="m">{{ 'general.monsieur' | translate }}</mat-option>
                            </mat-select>
                            <app-controls-messages [control]="laboDirecteurDivision"></app-controls-messages>
                          </fieldset>
                        </div>
                        <div class="col">
                          <fieldset class="form-group {{(!directeurDivisionNom.valid) ? 'form-error' : ''}}">
                            <label for="nomDir">{{ 'general.personne.nom' | translate }} <span class="star">*</span></label>
                            <input id="nomDir" type="text" class="form-control" #directeurDivisionNom="ngModel"
                              [(ngModel)]="laboratoire['directeurDivision']['personne']['nom']" required
                              [disabled]="disabled"
                              (ngModelChange)="updateLaboratoire.emit(laboratoire);">
                              <app-controls-messages [control]="directeurDivisionNom"></app-controls-messages>
                            </fieldset>
                          </div>
                          <div class="col">
                            <fieldset class="form-group {{(!prenomDir.valid) ? 'form-error' : ''}}">
                              <label for="prenomDir">{{ 'general.prenom' | translate }} <span class="star">*</span></label>
                              <input id="prenomDir" [disabled]="disabled" type="text" class="form-control" required
                                #prenomDir="ngModel"
                                [(ngModel)]="laboratoire['directeurDivision']['personne']['prenom']"
                                (ngModelChange)="updateLaboratoire.emit(laboratoire);">
                                <app-controls-messages [control]="prenomDir"></app-controls-messages>
                              </fieldset>
                            </div>
                          </div>
                        }
                        <!--Adresse-->
                        <div class="row mt-1">
                          <div class="col">
                            <h6 class="font-weight-bold">{{ 'moduleLaboratoire.adresseLaboratoire' | translate }}</h6>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col">
                            <form>
                              <app-geocoder #geocoder [instance]="'Adresse laboratoire'" [adresse]="laboratoire['adresse']"
                                [restrictCountryValue]="restrictCountryValue" [disabled]="disabled"
                              (place)="laboratoire['adresse'] = $event; updateLaboratoire.emit(this.laboratoire);"></app-geocoder>
                            </form>
                          </div>
                        </div>
                        <!--Tutelles-->
                        <div class="row">
                          <div class="col">
                            <hr class="separator-structure">
                            <span class="font-weight-bold encart-labo entete-part-labo">{{'moduleLaboratoire.tutelle' | translate}}</span>
                            <h6 [class.red-tutelle]="laboRefEnFrance() && !tutelleOk()"
                            class="font-weight-bold">{{ 'general.etablissementTutelle' | translate }}</h6>
                            <form>
                              <div class="row mt-1">
                                <div class="col-lg-2">
                                  <mat-checkbox name="xxxxx8" [(ngModel)]="uniteInsermSelected" [disabled]="disabled"
                                    (ngModelChange)="($event === false) ? uniteInsermSearch = ''  : ''; updateSelectBox($event, 'uniteInserm');">{{ 'general.laboratoire.unite_inserm' | translate }}
                                  </mat-checkbox>
                                </div>
                                <div class="col">
                                  <div class="form-group">
                                    <input [disabled]="!uniteInsermSelected || disabled" class="form-control tutelle-border"
                                      [ngClass]="(uniteInsermSearch !== '' && uniteInsermSearch!==null) ? 'tutelleSelected':'noTutelle'"
                                      [matAutocomplete]="autocomplete1" [(ngModel)]="uniteInsermSearch" name="xxxxx7"
                                      (focusout)="resetResearch('uniteInsermSearch','uniteInserm','filteredUniteInserm')"
                                      (ngModelChange)="filterSelect($event, 'uniteInserm', 'filteredUniteInserm'); updateSelect($event, 'uniteInserm','@id') ">
                                      <mat-autocomplete #autocomplete1="matAutocomplete" [displayWith]="displayAutoComplete()">
                                        @for (item of filteredUniteInserm; track item) {
                                          <mat-option [value]="item">
                                            @if (item.code === 'ZZZ_OTHER') {
                                              <span
                                              >{{ 'general.saisieLibre' | translate }}</span>
                                            }
                                            @if (item.code !== 'ZZZ_OTHER') {
                                              <span>{{item.code + ' - ' + item.titre}}</span>
                                            }
                                          </mat-option>
                                        }
                                      </mat-autocomplete>
                                    </div>
                                  </div>
                                  @if (uniteInsermSearch !== null && uniteInsermSearch !== undefined && uniteInsermSearch['code'] !== undefined && uniteInsermSearch['code'] === 'ZZZ_OTHER') {
                                    <div class="col-lg-4"
                                      >
                                      <div class="form-group">
                                        <input class="form-control" name="uniteInsermOther" type="text" [disabled]="disabled"
                                          placeholder="{{ 'front.editLaboReference.SaisirVotreUniteInserm' | translate }}"
                                          [(ngModel)]="laboratoire['uniteInsermOther']">
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  <div class="row">
                                    <div class="col-lg-2">
                                      <mat-checkbox name="xxxxx5" [(ngModel)]="uniteCnrsSelected" [disabled]="disabled"
                                        (ngModelChange)="($event === false) ? uniteCnrsSearch = ''  : '' ; updateSelectBox($event, 'uniteCnrs')">{{ 'general.laboratoire.unite_cnrs' | translate }}
                                      </mat-checkbox>
                                    </div>
                                    <div class="col">
                                      <div class="form-group">
                                        <input [disabled]="!uniteCnrsSelected || disabled" class="form-control tutelle-border"
                                          [ngClass]="(uniteCnrsSearch !== '' && uniteCnrsSearch!==null) ?'tutelleSelected':'noTutelle'"
                                          [matAutocomplete]="autocomplete2" [(ngModel)]="uniteCnrsSearch" name="xxxxx6"
                                          (focusout)="resetResearch('uniteCnrsSearch','uniteCnrs','filterdUniteCnrs')"
                                          (ngModelChange)="filterSelect($event, 'uniteCnrs', 'filterdUniteCnrs'); updateSelect($event, 'uniteCnrs','@id') ">
                                          <mat-autocomplete #autocomplete2="matAutocomplete" [displayWith]="displayAutoComplete()">
                                            @for (item of filterdUniteCnrs; track item) {
                                              <mat-option [value]="item">
                                                @if (item.code === 'ZZZ_OTHER') {
                                                  <span
                                                  >{{ 'general.saisieLibre' | translate }}</span>
                                                }
                                                @if (item.code !== 'ZZZ_OTHER') {
                                                  <span>{{item.code + ' - ' + item.titre}}</span>
                                                }
                                              </mat-option>
                                            }
                                          </mat-autocomplete>
                                        </div>
                                      </div>
                                      @if (uniteCnrsSearch !== undefined && uniteCnrsSearch !== null && uniteCnrsSearch['code'] !== undefined && uniteCnrsSearch['code'] === 'ZZZ_OTHER') {
                                        <div class="col-lg-4"
                                          >
                                          <div class="form-group">
                                            <input class="form-control" name="uniteCnrsOther" type="text" [disabled]="disabled"
                                              placeholder="{{ 'front.editLaboReference.SaisirVotreUniteCnrs' | translate }}"
                                              [(ngModel)]="laboratoire['uniteCnrsOther']"
                                              (ngModelChange)="updateLaboratoire.emit(laboratoire);">
                                            </div>
                                          </div>
                                        }
                                      </div>
                                      <div class="row">
                                        <div class="col-lg-2">
                                          <mat-checkbox name="xxxxx2" [(ngModel)]="universiteFaculteSelected" [disabled]="disabled"
                                            (ngModelChange)="($event === false) ? universiteFaculteSearch = ''  : ''; updateSelectBox($event, 'universiteFaculte')">
                                            {{ 'general.univFaculte' | translate }}
                                          </mat-checkbox>
                                        </div>
                                        <div class="col">
                                          <div class="form-group">
                                            <input [disabled]="!universiteFaculteSelected || disabled"
                                              class="form-control tutelle-border"
                                              [ngClass]="(universiteFaculteSearch !== '' && universiteFaculteSearch!==null) ? 'tutelleSelected':'noTutelle'"
                                              [matAutocomplete]="autocomplete3" [(ngModel)]="universiteFaculteSearch"
                                              name="xxxxx1"
                                              (focusout)="resetResearch('universiteFaculteSearch','universiteFaculte','filteredUniversiteFaculte')"
                                              (ngModelChange)="filterSelectLabel($event, 'universiteFaculte', 'filteredUniversiteFaculte'); updateSelect($event, 'universiteFaculte','@id') ">
                                              <mat-autocomplete #autocomplete3="matAutocomplete"
                                                [displayWith]="displayAutoCompleteLabel()">
                                                @for (item of filteredUniversiteFaculte; track item) {
                                                  <mat-option [value]="item">
                                                    @if (item.titre === 'ZZZ_OTHER') {
                                                      <span
                                                      >{{ 'general.saisieLibre' | translate }}</span>
                                                    }
                                                    @if (item.titre !== 'ZZZ_OTHER') {
                                                      <span>{{item.titre}}</span>
                                                    }
                                                  </mat-option>
                                                }
                                              </mat-autocomplete>
                                            </div>
                                          </div>
                                          @if (universiteFaculteSearch !== undefined && universiteFaculteSearch !== null && universiteFaculteSearch['titre'] !== undefined && universiteFaculteSearch['titre'] === 'ZZZ_OTHER') {
                                            <div class="col-lg-4"
                                              >
                                              <div class="form-group">
                                                <input class="form-control" name="universiteFaculteOther" type="text"
                                                  placeholder="{{ 'general.saisirVotreFaculteUniv' | translate }}"
                                                  [(ngModel)]="laboratoire['universiteFaculteOther']"
                                                  (ngModelChange)="updateLaboratoire.emit(laboratoire);" [disabled]="disabled">
                                                </div>
                                              </div>
                                            }
                                          </div>
                                          <div class="row">
                                            <div class="col-lg-2">
                                              <mat-checkbox [disabled]="disabled" name="xxxxx10"
                                                [(ngModel)]="laboratoire['autreEtablissementTutelleBool']"
                                                (ngModelChange)="updateSelectBox($event, 'autreEtablissementTutelleText')">
                                                {{ 'general.autres' | translate }}
                                              </mat-checkbox>
                                            </div>
                                            <div class="col-lg-10">
                                              <div class="form-group">
                                                <input class="form-control tutelle-border" name="xxxxx11"
                                                  [ngClass]="(laboratoire['autreEtablissementTutelleText'] !== '' && laboratoire['autreEtablissementTutelleText']!==null) ? 'tutelleSelected':'noTutelle'"
                                                  [disabled]="!laboratoire.autreEtablissementTutelleBool || disabled"
                                                  placeholder="{{ 'moduleLaboratoire.exempleCeaInraHopitaux' | translate }}"
                                                  type="text" id="autreselement"
                                                  [(ngModel)]="laboratoire['autreEtablissementTutelleText']"
                                                  (ngModelChange)="updateLaboratoire.emit(laboratoire);">
                                                </div>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
